import { customActions } from './custom-actions';
import { createListStore } from 'common/store';
import { INITIAL_STATE } from './constants';
export var createChatMembersStore = function () {
    return createListStore({
        initialValues: INITIAL_STATE,
        customActions: customActions,
    });
};
export var useChatMembersStore = createChatMembersStore();
